import React, { ReactNode } from 'react'
import clsx from 'clsx'

import Link from '@material-ui/core/Link'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import Box from '@material-ui/core/Box'
import makeStyles from '@material-ui/styles/makeStyles'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import useTheme from '@material-ui/core/styles/useTheme'

import ReplayIcon from '@material-ui/icons/Replay'

import { SpacedGroup } from '@guidde-co/shared.spaced-group'

import GuiddeIcon from './guidde-white-icon.svg'
import UArrowIcon from './arrow-u-right-top.svg'

const RollBackIcon = () => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M9.95078 18.7501C8.41745 18.7501 7.09245 18.2501 5.97578 17.2501C4.85911 16.2501 4.30078 15.0001 4.30078 13.5001C4.30078 12.0001 4.85911 10.7501 5.97578 9.7501C7.09245 8.7501 8.41745 8.2501 9.95078 8.2501H16.8508L14.0008 5.4001L15.0508 4.3501L19.7008 9.0001L15.0508 13.6501L14.0008 12.6001L16.8508 9.7501H9.95078C8.83411 9.7501 7.86345 10.1041 7.03878 10.8121C6.21345 11.5208 5.80078 12.4168 5.80078 13.5001C5.80078 14.5834 6.21345 15.4794 7.03878 16.1881C7.86345 16.8961 8.83411 17.2501 9.95078 17.2501H16.8008V18.7501H9.95078Z"
            fill="white"
        />
    </svg>
)

const ShareIcon = () => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <mask
            id="mask0_4376_8363"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="24"
            height="24"
        >
            <rect width="24" height="24" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_4376_8363)">
            <path
                d="M18 21.75C17.2333 21.75 16.5833 21.4833 16.05 20.95C15.5167 20.4167 15.25 19.7667 15.25 19C15.25 18.8833 15.2583 18.754 15.275 18.612C15.2917 18.4707 15.325 18.35 15.375 18.25L7.975 13.9C7.70833 14.1667 7.40833 14.375 7.075 14.525C6.74167 14.675 6.38333 14.75 6 14.75C5.23333 14.75 4.58333 14.4833 4.05 13.95C3.51667 13.4167 3.25 12.7667 3.25 12C3.25 11.2333 3.51667 10.5833 4.05 10.05C4.58333 9.51667 5.23333 9.25 6 9.25C6.38333 9.25 6.74167 9.325 7.075 9.475C7.40833 9.625 7.70833 9.83333 7.975 10.1L15.375 5.75C15.325 5.65 15.2917 5.529 15.275 5.387C15.2583 5.24567 15.25 5.11667 15.25 5C15.25 4.23333 15.5167 3.58333 16.05 3.05C16.5833 2.51667 17.2333 2.25 18 2.25C18.7667 2.25 19.4167 2.51667 19.95 3.05C20.4833 3.58333 20.75 4.23333 20.75 5C20.75 5.76667 20.4833 6.41667 19.95 6.95C19.4167 7.48333 18.7667 7.75 18 7.75C17.6167 7.75 17.2583 7.675 16.925 7.525C16.5917 7.375 16.2917 7.16667 16.025 6.9L8.625 11.25C8.675 11.35 8.70833 11.4667 8.725 11.6C8.74167 11.7333 8.75 11.8667 8.75 12C8.75 12.1167 8.74167 12.2457 8.725 12.387C8.70833 12.529 8.675 12.65 8.625 12.75L16.025 17.1C16.2917 16.8333 16.5917 16.625 16.925 16.475C17.2583 16.325 17.6167 16.25 18 16.25C18.7667 16.25 19.4167 16.5167 19.95 17.05C20.4833 17.5833 20.75 18.2333 20.75 19C20.75 19.7667 20.4833 20.4167 19.95 20.95C19.4167 21.4833 18.7667 21.75 18 21.75ZM18 6.25C18.35 6.25 18.646 6.129 18.888 5.887C19.1293 5.64567 19.25 5.35 19.25 5C19.25 4.65 19.1293 4.354 18.888 4.112C18.646 3.87067 18.35 3.75 18 3.75C17.65 3.75 17.3543 3.87067 17.113 4.112C16.871 4.354 16.75 4.65 16.75 5C16.75 5.35 16.871 5.64567 17.113 5.887C17.3543 6.129 17.65 6.25 18 6.25ZM6 13.25C6.35 13.25 6.646 13.129 6.888 12.887C7.12933 12.6457 7.25 12.35 7.25 12C7.25 11.65 7.12933 11.3543 6.888 11.113C6.646 10.871 6.35 10.75 6 10.75C5.65 10.75 5.35433 10.871 5.113 11.113C4.871 11.3543 4.75 11.65 4.75 12C4.75 12.35 4.871 12.6457 5.113 12.887C5.35433 13.129 5.65 13.25 6 13.25ZM18 20.25C18.35 20.25 18.646 20.129 18.888 19.887C19.1293 19.6457 19.25 19.35 19.25 19C19.25 18.65 19.1293 18.3543 18.888 18.113C18.646 17.871 18.35 17.75 18 17.75C17.65 17.75 17.3543 17.871 17.113 18.113C16.871 18.3543 16.75 18.65 16.75 19C16.75 19.35 16.871 19.6457 17.113 19.887C17.3543 20.129 17.65 20.25 18 20.25Z"
                fill="white"
            />
        </g>
    </svg>
)
type StylesType = {
    isVisible: boolean
}

const useStyles = makeStyles({
    container: {
        opacity: ({ isVisible }: StylesType) => (isVisible ? 1 : 0),
        visibility: ({ isVisible }: StylesType) =>
            isVisible ? 'visible' : 'hidden',
        transition: '1s linear opacity',
        position: 'absolute',
        top: 0,
        bottom: 0,
        background: 'rgba(0, 0, 0, 0.7)',
        backdropFilter: 'blur(3px)',
        color: 'white',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
        '& button': {
            fontWeight: 600
        },
        zIndex: 10
    },
    guiddeIconWrapper: {
        height: '40px',
        width: '40px',
        backgroundColor: '#CB0000',
        borderRadius: '5px',
        whiteSpace: 'nowrap'
    },
    guiddeIcon: {
        backgroundColor: '#CB0000'
    },
    link: {
        color: 'white',
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'none'
        }
    },
    actionButton: {
        color: 'white !important',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        boxShadow: 'none',
        padding: '5px 20px',
        '& *': {
            textTransform: 'none',
            whiteSpace: 'nowrap'
        }
    },
    red: {
        backgroundColor: '#CB0000 !important'
    },
    startIcon: {
        marginRight: '0 !important'
    },
    learnMoreButton: {
        borderColor: 'white !important'
    }
})

export type VideoOverlayProps = {
    /**
     * Handle click on watch button
     */
    onWatch: () => void
    /**
     * Handle click on watch share button
     */
    onShare?: () => void
    /**
     * watch label text
     */
    watchLabel: string
    /**
     * Title text
     */
    title: string
    /**
     * Subtitle text
     */
    subtitle?: ReactNode
    /**
     * Whether to show the overlay
     */
    isVisible: boolean
    /**
     * Learn more link
     */
    learnMoreLink?: string
    /**
     * Use Guidde for free  link
     */
    useGuiddeForFreeLink?: string
    /**
     * Get started link
     */
    getStartedLink?: string
}

export const VideoOverlay = ({
    onWatch,
    onShare,
    watchLabel,
    isVisible,
    title,
    subtitle = (
        <>
            The simplest way to deliver video-based knowledge for any
            application or business <br /> process. Securely and in-context
        </>
    ),
    learnMoreLink,
    getStartedLink,
    useGuiddeForFreeLink
}: VideoOverlayProps) => {
    const classes = useStyles({ isVisible })

    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
    const isLargeDesktop = useMediaQuery(theme.breakpoints.up('lg'))

    return (
        <Box
            display="flex"
            justifyContent="center"
            className={classes.container}
        >
            <Box
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                width={isMobile ? '95%' : '80%'}
            >
                <Box
                    className={classes.guiddeIconWrapper}
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                >
                    <img src={GuiddeIcon} className={classes.guiddeIcon} />
                </Box>
                <Box my={isMobile ? 1.5 : 3}>
                    <Typography
                        style={{
                            fontSize: isLargeDesktop ? '30px' : '20px',
                            fontWeight: 600
                        }}
                    >
                        {title}
                    </Typography>
                </Box>
                <Box mb={3}>
                    <Typography
                        variant="body2"
                        style={{ fontSize: isLargeDesktop ? '20px' : '16px' }}
                    >
                        {subtitle}
                    </Typography>
                </Box>

                <Box
                    mt={isMobile ? 0 : 3}
                    mb={isMobile ? 0 : 4}
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    style={{ gap: 28 }}
                >
                    {useGuiddeForFreeLink && (
                        <Link
                            className={classes.link}
                            style={{
                                textTransform: 'uppercase',
                                letterSpacing: '1.25px'
                            }}
                            href={useGuiddeForFreeLink}
                            rel="noreferrer noopener"
                            target="_blank"
                        >
                            <Button
                                variant="contained"
                                size={isLargeDesktop ? 'large' : 'small'}
                                disableElevation
                                style={{
                                    width: 280
                                }}
                                classes={{
                                    root: clsx(
                                        classes.actionButton,
                                        classes.red
                                    )
                                }}
                                startIcon={<RollBackIcon />}
                            >
                                USE GUIDDE FOR FREE
                            </Button>
                        </Link>
                    )}
                    {learnMoreLink && (
                        <Link
                            className={classes.link}
                            href={learnMoreLink}
                            rel="noreferrer noopener"
                            target="_blank"
                        >
                            <Button
                                variant="outlined"
                                size={isLargeDesktop ? 'large' : 'small'}
                                classes={{
                                    root: clsx(
                                        classes.actionButton,
                                        classes.learnMoreButton
                                    )
                                }}
                            >
                                Learn more
                            </Button>
                        </Link>
                    )}
                    {getStartedLink && (
                        <Link
                            className={classes.link}
                            href={getStartedLink}
                            rel="noreferrer noopener"
                            target="_blank"
                        >
                            <Button
                                variant="contained"
                                size={isLargeDesktop ? 'large' : 'small'}
                                disableElevation
                                classes={{
                                    root: clsx(
                                        classes.actionButton,
                                        classes.red
                                    )
                                }}
                                startIcon={
                                    <img
                                        src={UArrowIcon}
                                        className={classes.startIcon}
                                    />
                                }
                            >
                                Get Started
                            </Button>
                        </Link>
                    )}
                </Box>
                <SpacedGroup my={1} display="flex" justifyContent="center">
                    <Button
                        className={clsx(classes.actionButton)}
                        color="default"
                        variant="text"
                        size={isLargeDesktop ? 'large' : 'small'}
                        onClick={onWatch}
                        startIcon={<ReplayIcon fontSize="small" />}
                    >
                        {watchLabel}
                    </Button>
                    {onShare && (
                        <Button
                            className={clsx(classes.actionButton)}
                            color="default"
                            variant="text"
                            size={isLargeDesktop ? 'large' : 'small'}
                            onClick={onShare}
                            startIcon={<ShareIcon />}
                        >
                            Share
                        </Button>
                    )}
                </SpacedGroup>
            </Box>
        </Box>
    )
}
